import React from "react";

// Explicit selects avoid inconsistent native time-input behaviour on Android.
export default function StaffTimePicker({ value = "", onChange, disabled, label = "Time", className = "", "data-testid": testId }) {
    const [hour = "", minute = ""] = value.split(":");
    const options = (count) => Array.from({ length: count }, (_, i) => String(i).padStart(2, "0"));
    return <span className={`flex items-center gap-2 ${className}`} data-testid={testId}>
        <select aria-label={`${label} hour`} disabled={disabled} value={hour}
            onChange={e => onChange(e.target.value ? `${e.target.value}:${minute || "00"}` : "")}
            style={{ background: "white", color: "#111b36", minHeight: 44 }} className="min-w-0 flex-1 rounded-lg border px-2">
            <option value="" disabled>Hour</option>{options(24).map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span aria-hidden="true">:</span>
        <select aria-label={`${label} minute`} disabled={disabled} value={minute}
            onChange={e => onChange(e.target.value ? `${hour || "00"}:${e.target.value}` : "")}
            style={{ background: "white", color: "#111b36", minHeight: 44 }} className="min-w-0 flex-1 rounded-lg border px-2">
            <option value="" disabled>Minute</option>{options(60).map(n => <option key={n} value={n}>{n}</option>)}
        </select>
    </span>;
}
